import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import GoogleMapScript from "./component";
import { scriptLoaded } from "../../shared/scripts-loader/actions";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    scriptLoadedConnect: scriptLoaded
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(GoogleMapScript);
